

<template>
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item v-for="(item,index) in breadcrumb" :key="item.path" :breadcrumb="breadcrumb"><a :href="item.path">{{ item.meta.title }}</a></el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default  {
  data(){
    return{
      breadcrumb:[]
    }
  },
  mounted() {
    this.breadcrumb = this.$route.matched
  },
  // 监听函数
  watch:{
    $route(to,from)  {
      this.breadcrumb = to.matched
    }
  }

}
</script>

<style scoped>
.el-breadcrumb {
    position: absolute;
    margin: 1rem;
    font-size: 1rem;
    font-weight: 700;
  }
</style>
